const ServiceIDByLabel = {
  "Owner Accounts": "VAccount",
  "Remitter Accounts": "REVAccount",
  "Private Transactions": "VPrivateTransaction",
  "Beneficiary Accounts": "BVAccount",
  "Beneficiary Transactions": "VBeneficiaryTxn",
  "Internal Accounts": "IVAccount",
  "Internal Transactions": "VInternalTxn",
  "Reimbursement Accounts": "RVAccount",
  "Reimbursement Transactions": "VReimbursementTxn",
  "Field Force Accounts": "FFVAccount",
  "Field Force Transactions": "VReimbursementTxn",
  "Tax Accounts": "VTDSAccount",
  "Tax Transactions": "VTDSTransaction",
  // "Field Force Transactions": "FVTransaction",
  // "Income Transactions": "VDIncome",
  // "Nodal Transactions": "VDNodal",
  // "Adjustment Transactions": "",
  // "Chargeback Transactions": "VChargeback",
  // "Duplicate Transactions": "",
  // "InstantPay": "ViewMaintenanceAccount",
  // "Vendor Accounts": "VAccount",
  // "Client Accounts": "VAccount",
  // "Cards Accounts": "VCard",
  // "InstantPay Accounts": "VInstantTxn",
};

export default ServiceIDByLabel;
